import { routes } from '@/app/routing/router'
import { RecommendationsView } from './view'

const currentRoute = routes.recommendations

const RecommendationsPageRoute = {
  view: RecommendationsView,
  route: currentRoute,
}

export { currentRoute, RecommendationsPageRoute }
